import React from 'react'
import KeyboardScanModal from './KeyboardScanModal'

/**
 * HOC that provides keyboard scan modal functionality
 */
export const withKeyboardScanModal = (Component) => {
  return class KeyboardScanModalWrapper extends React.Component {
    state = {
      isShow: false,
      onScanSuccess: null,
    }

    handleShowModal = (onScanSuccess) => {
      this.setState({
        isShow: true,
        onScanSuccess: onScanSuccess || null,
      })
    }

    handleHide = () => {
      this.setState({
        isShow: false,
        onScanSuccess: null,
      })
    }

    render() {
      return (
        <div>
          <Component
            {...this.props}
            isKeyboardScanModalShow={this.state.isShow}
            showKeyboardScanModal={this.handleShowModal}
            hideKeyboardScanModal={this.handleHide}
          />

          {this.state.isShow && (
            <KeyboardScanModal onCancel={this.handleHide} />
          )}
        </div>
      )
    }
  }
}
